import { Injectable } from '@angular/core';
import { filter, fromEvent, map, Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  init(): Observable<void> {
    return of();
  }

  get(key: string): string | null {
    return localStorage.getItem(key);
  }

  remove(key: string): void {
    localStorage.removeItem(key);
  }

  set(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  clear(): void {
    localStorage.clear();
  }

  onStorageEvent(): Observable<StorageEvent> {
    return fromEvent<StorageEvent>(window, 'storage').pipe(
      filter(event => event.storageArea === localStorage)
    );
  }

  onNewValue(key: string): Observable<string | null> {
    return this.onStorageEvent().pipe(
      filter(event => event.key === key),
      map(event => event.newValue)
    );
  }
}
